/* src/app/main/ageing/list/ageing-list.component.scss */
/*# sourceMappingURL=ageing-list.component-AZVSIGPP.css.map */
